var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_585_7972)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9063 2.18128L15.2938 0.793775C15.8813 0.206275 16.8313 0.206275 17.4126 0.793775L29.5625 12.9375C30.15 13.525 30.15 14.475 29.5625 15.0563L17.4188 27.2C16.8313 27.7875 15.8813 27.7875 15.3 27.2L13.9126 25.8125C13.3188 25.2188 13.3313 24.25 13.9375 23.6688L21.4625 16.5L3.50005 16.5C2.6688 16.5 2.00005 15.8313 2.00005 15L2.00005 13C2.00005 12.1688 2.6688 11.5 3.50005 11.5L21.4625 11.5L13.9313 4.32502C13.3188 3.74377 13.3063 2.77503 13.9063 2.18128Z",
    fill: "#AD4D34"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_585_7972"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 32,
    fill: "white",
    transform: "translate(32 1.39876e-06) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.2f555d877fd3d49f2e4831c2f5828d7d.svg";
export { ForwardRef as ReactComponent };